/**
 * FIXME: This should be moved out of the functions directory because it is DigiTickets specific.
 * 'functions' should only be for generic utilities.
 */
const ItemType = require('@/lib/Items/ItemType');

/**
 * @param {Order} order
 *
 * @return {?OrderLine}
 */
const orderContainsGiftVouchers = (order) => order.items.find((line) => line.itemType === ItemType.GIFT_VOUCHER);

/**
 * @param {number} currentBranchID
 * @param {Order} order
 * @param {OrderLine[]} lines
 *
 * @return {boolean}
 */
const orderIsCrossBranch = (currentBranchID, order, lines) => {
    if (order.orderBranchID !== currentBranchID) {
        return true;
    }

    for (let i = 0; i < lines.length; i++) {
        if (lines[i].branchID !== currentBranchID) {
            return true;
        }
    }

    return false;
};

module.exports = {
    orderContainsGiftVouchers,
    orderIsCrossBranch,
};
